import config from '@/config';
import { fetchData } from '@/model/utils/fetch';

export const fetchAuthToken = async () => {
  try {
    const response = await fetchData<{
      [key: string]: any;
    }>({
      url: `${config.urls.bffBaseUrl}/auth?token=true`,
    });
    return response || {};
  } catch (e) {
    console.error(e);
    return {};
  }
};
